export const formatBoostUnlockAt = (value?: string | null) => {
  if (!value) return null;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  return date.toLocaleString();
};

export const getCooldownBlockedMessage = (
  unlockAt?: string | null,
  cooldownDays?: number | null,
) => {
  const formattedUnlockAt = formatBoostUnlockAt(unlockAt);
  if (formattedUnlockAt) {
    return `Regenerate is on cooldown until ${formattedUnlockAt}.`;
  }
  if (typeof cooldownDays === "number" && Number.isFinite(cooldownDays)) {
    return `Regenerate is on cooldown for ${cooldownDays} day${cooldownDays === 1 ? "" : "s"}.`;
  }
  return "Regenerate is on cooldown. Please try again later.";
};

export const getTrialBoostBlockedInfo = (payload: any) => {
  const asString = (value: unknown) => String(value || "").trim().toLowerCase();
  const readStringField = (keys: string[]) => {
    for (const key of keys) {
      const value = payload?.[key];
      if (typeof value === "string" && value.trim()) return value.trim();
    }
    return null;
  };
  const reason = asString(payload?.reason || payload?.code || payload?.errorCode);
  const status = asString(payload?.status);
  const message = asString(payload?.message || payload?.error);
  const blocked =
    reason.includes("trial_boost_limit") ||
    reason.includes("trial_cluster_limit_reached") ||
    reason.includes("trial_strategy_limit_reached") ||
    reason.includes("cluster_limit_reached") ||
    reason.includes("boost_limit_reached") ||
    reason.includes("boost_limit") ||
    message.includes("boost limit reached") ||
    (status === "blocked" && (reason.includes("trial") || message.includes("trial")));

  return {
    blocked,
    trialBoostedClusterId: readStringField([
      "trialBoostedClusterId",
      "trial_boosted_cluster_id",
      "boostedClusterId",
      "boosted_cluster_id",
      "existingClusterId",
      "existing_cluster_id",
    ]),
  };
};

export const shouldBlockBoostByCooldown = (
  isCooldownLocked: boolean,
  _isRegenerateAction: boolean,
) => isCooldownLocked;

export const getPromptRunsBlockedMessage = (
  queuedOrRunning: number,
  total: number,
) =>
  `Boost is blocked: ${queuedOrRunning}/${total} prompts are queued or running`;
